module.exports = __webpack_public_path__ + "img/breakfast.1cc09090.svg";